import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function UnpinIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.21967 4.21967C4.51256 3.92678 4.98744 3.92678 5.28033 4.21967L8 6.93934V6.75C8 6.02065 8.28973 5.32118 8.80546 4.80546C9.32118 4.28973 10.0207 4 10.75 4H13.25C13.9793 4 14.6788 4.28973 15.1945 4.80546C15.7103 5.32118 16 6.02065 16 6.75V9.86198L17.9509 14.983C18.0387 15.2135 18.0075 15.4725 17.8676 15.6756C17.7276 15.8787 17.4967 16 17.25 16H17.0607L19.7803 18.7197C20.0732 19.0126 20.0732 19.4874 19.7803 19.7803C19.4874 20.0732 19.0126 20.0732 18.7197 19.7803L4.21967 5.28033C3.92678 4.98744 3.92678 4.51256 4.21967 4.21967ZM16.1617 14.5H15.5607L9.5 8.43934V6.75C9.5 6.41848 9.6317 6.10054 9.86612 5.86612C10.1005 5.6317 10.4185 5.5 10.75 5.5H13.25C13.5815 5.5 13.8995 5.6317 14.1339 5.86612C14.3683 6.10054 14.5 6.41848 14.5 6.75V10C14.5 10.0912 14.5167 10.1817 14.5491 10.267L16.1617 14.5ZM8.25498 11.2991C8.64206 11.4466 8.83632 11.8799 8.68887 12.267L7.83826 14.5H12C12.4142 14.5 12.75 14.8358 12.75 15.25V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V16H6.75C6.50333 16 6.27243 15.8787 6.13245 15.6756C5.99247 15.4725 5.96132 15.2135 6.04913 14.983L7.28713 11.733C7.43458 11.3459 7.8679 11.1517 8.25498 11.2991Z"
        fill="currentColor"
      />
    </svg>
  );
};
